const formatLabel = {
  creation: 'criou o equipamento.',
  changeStatusT: 'Inativou',
  changeStatusT1: 'o equipamento.',
  changeStatusF: 'Reativou',
  changeStatusF1: 'o equipamento.',
  changeMaintenanceStatusT: 'retornou',
  changeMaintenanceStatusT1: 'o equipamento da manutenção.',
  changeMaintenanceStatusF: 'enviou',
  changeMaintenanceStatusF1: 'o equipamento para manutenção.',
  changePlace: ' modificou o local de ',
  changePlace1: ' para ',
  changePlace2: ' removeu o local ',
  changePlace3: ' do equipamento.',
  changePlace4: ' modificou o local para ',
  changeSite: ' modificou o site de ',
  changeSite1: ' para ',
  changeSite2: ' removeu o site ',
  changeSite3: ' do equipamento.',
  changeSite4: ' modificou o site para ',
  changePhoto: ' modificou a foto.',
  changeEquipmentModel: ' atualizou o tipo do equipamento de ',
  changeEquipmentModel1: ' para ',
  changeEquipmentModel2: ' removeu o tipo do equipamento ',
  changeEquipmentModel3: ' modificou o tipo do equipamento para ',
  changeCompany: ' atualizou a empresa de ',
  changeCompany1: ' para ',
  changeCompany2: ' removeu a empresa ',
  changeCompany3: ' do equipamento.',
  changeCompany4: ' modificou a empresa para ',
  changeReference: ' atualizou o ponto de referência ',
  changeReference1: 'de ',
  changeReference2: ' para ',
  changeSerialNumber: ' atualizou o número de série ',
  changeSerialNumber1: 'de ',
  changeSerialNumber2: ' para ',
  changeDescription: ' atualizou as especificações do equipmento ',
  changeDescription1: 'de ',
  changeDescription2: ' para ',
  changeBrand: ' atualizou a marca do equipamento ',
  changeBrand1: 'de ',
  changeBrand2: ' para ',
  changeBrand3: ' atualizou a marca do equipamento para ',
  default: 'Esse equipamento foi atualizado.',
  removedCompanies: 'removeu as empresas',
  removedCompany: 'removeu a empresa',
  addedCompanies: 'adicionou as empresas',
  addedCompany: 'adicionou a empresa',
  andString: 'e',
};

export default formatLabel;
